exports = module.exports = require("../../../../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FieldColor{margin-bottom:20px}.FieldColor .color-items{display:flex;flex-wrap:wrap;margin-top:10px;margin-bottom:5px}.FieldColor .color-items .color_item{cursor:pointer;height:32px;width:48px;margin:4px;border-radius:2px;display:flex;align-items:center;justify-content:center;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Labels/components/FormData/components/FormLabel/components/FieldColor/style.scss
// module id = 2587
// module chunks = 0